"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var DiscountPercentage = function (_a) {
    var discountPercent = _a.discountPercent, upTo = _a.upTo;
    return ((0, preact_1.h)("div", { class: "signup-discount" },
        (0, preact_1.h)("p", { class: "signup-discount__text" },
            upTo ? 'up to' : '',
            (0, preact_1.h)("b", { class: "signup-discount__text signup-discount__text--type signup-discount__text--line-height" },
                ' ',
                discountPercent,
                " OFF",
                ' '),
            (0, preact_1.h)("span", { class: "signup-discount__subtext" },
                "Sign up for special offers",
                (0, preact_1.h)("br", null),
                "and new product launches."))));
};
exports.default = DiscountPercentage;
